import React, { useState } from 'react';
import {
  Button,
  DisplayText,
  Popover,
  ResourceItem,
  ResourceList
} from '@superops/ui-design-system';
import {
  AccessControl,
  getTranslatedText,
  useIsAuthorisedHook,
  useUserMSPCheckHookBasedOnProduct
} from '@nile/components';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  MAC_POLICY_SET_ID,
  WINDOWS_POLICY_SET_ID
} from '@nile/banyan/src/Constants/policySet';
import { useChatFeatureEnabled } from '@nile/components/src/Pages/SystemTrayChatPage/utils';

function AlertActionsCell(props) {
  const { cell, intl, column } = props;

  const { original: alert } = cell?.row;

  const { actions } = cell.column;

  const isMSP = useUserMSPCheckHookBasedOnProduct();
  const isTicketEditAuthorised = useIsAuthorisedHook('tickets.edit');
  const isTicketAddAuthorised = useIsAuthorisedHook('tickets.add');
  const isChatAvailable = useChatFeatureEnabled();
  const isUserChatAuthorised = isTicketAddAuthorised && isTicketEditAuthorised;

  const [popoverActive, setPopoverActive] = useState(false);
  const flags = useFlags();

  const togglePopover = () => {
    setPopoverActive(!popoverActive);
  };

  const options = [
    {
      name: 'MOVE_ALERT_AS_TICKET',
      label: getTranslatedText(intl, 'asset.alertView.moveAlertAsTicket.label'),
      icon: 'TicketOutline'
    }
  ];

  const assetClassId =
    alert?.asset?.assetClass?.classId || column?.meta?.assetClass?.classId;
  const enableAlertToChat =
    flags?.agentChatFe &&
    isMSP &&
    isUserChatAuthorised &&
    isChatAvailable &&
    (assetClassId === WINDOWS_POLICY_SET_ID ||
      assetClassId === MAC_POLICY_SET_ID);

  if (enableAlertToChat) {
    options.push({
      name: 'MOVE_ALERT_AS_TICKET_INITIATE_CHAT',
      label: getTranslatedText(
        intl,
        'Convert alert into a ticket and initiate chat'
      ),
      icon: 'TicketOutline'
    });
  }

  const sections = [
    {
      name: getTranslatedText(intl, 'asset.alertView.ticketing.header'),
      options: options
    }
  ];

  const getActivator = () => {
    return (
      <Button plain icon={<SVGIcon name="Actions" />} onClick={togglePopover} />
    );
  };

  const performAction = (option) => {
    togglePopover();
    switch (option.name) {
      case 'MOVE_ALERT_AS_TICKET':
        actions.onClick(alert);
        break;
      case 'MOVE_ALERT_AS_TICKET_INITIATE_CHAT':
        actions.onClick(alert, 'CHAT');
        break;
      default:
        break;
    }
  };

  const CreateTicketPopup = (
    <div>
      <Popover
        active={popoverActive}
        activator={getActivator()}
        onClose={togglePopover}
      >
        <ResourceList
          items={sections}
          renderItem={(el) => {
            return (
              <div className="flex col" key={el.name}>
                <div className="mb5 mt5 pl10">
                  <DisplayText size="medium" weight="Medium">
                    {el?.name}
                  </DisplayText>
                </div>
                {el?.options.map((option) => {
                  return (
                    <ResourceItem gutter="xs" verticalAlignment="center">
                      <div className="pl10 pr10">
                        <Button
                          plain
                          monochrome
                          icon={<SVGIcon name={option.icon} />}
                          onClick={() => performAction(option)}
                          key={option.label}
                        >
                          {option.label}
                        </Button>
                      </div>
                    </ResourceItem>
                  );
                })}
              </div>
            );
          }}
        />
      </Popover>
    </div>
  );

  return flags?.agentChatFe && isChatAvailable ? (
    <AccessControl roleToCheck="tickets.add" render={CreateTicketPopup} />
  ) : (
    <>{CreateTicketPopup}</>
  );
}

export default injectIntl(AlertActionsCell);
